export default __webpack_public_path__ + "static/ring6-3bbf9a9a008a13bc766edb7cf575bd40.png";